/* eslint-disable react/display-name */
import { useSelector } from 'react-redux'

import { ICompany, IMe, selectCompanyInfo, selectMeInfo } from '@store/me'

export interface IMeInfoProps {
  meInfo: IMe
  companyInfo?: ICompany
}

/**
 * Custom hook for accessing me info and company info
 * @returns {IMeInfoProps} Object containing meInfo and companyInfo
 * @example
 * const { meInfo, companyInfo } = useMeInfo()
 */
export const useMeInfo = (): IMeInfoProps => {
  const meInfo = useSelector(selectMeInfo)
  const companyInfo = useSelector(selectCompanyInfo)

  return {
    meInfo,
    companyInfo,
  }
}

/**
 * @deprecated Use useMeInfo hook instead
 * HOC that injects meInfo and companyInfo props
 */
export const withMeInfo = <P extends object>(Component: React.ComponentType<P & IMeInfoProps>) => {
  return (props: P) => {
    const { meInfo, companyInfo } = useMeInfo()
    return <Component {...props} meInfo={meInfo} companyInfo={companyInfo} />
  }
}

export default withMeInfo
